import mainStyle from './mainStyle.module.scss';

import { useState, useEffect } from 'react';

import { Checkbox, IconButton, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { ReactComponent as CheckBoxDefault } from 'assets/images/icons/checkbox_default.svg';
import { ReactComponent as CheckClearIcon } from 'assets/images/icons/checkbox_clear.svg';
import { ReactComponent as CheckBoxFilled } from 'assets/images/icons/checkbox_fiilled.svg';
import { ReactComponent as PreviewIcon } from 'assets/images/icons/icn_table_cell_ViewAll.svg';
import { ReactComponent as PreviewHoverIcon } from 'assets/images/icons/icn_table_cell_ViewAll_hover.svg';

const CaptivePortalTable = ({
  tableData,
  setTableData,
  hasChecked,
  setHasChecked,
  setIsSelectedCount,
  selectedRowItem,
  setSelectedRowItem,
  setDrawerOpen,
  currentPage,
  rowsPerPage,
  setOpenPreviewModal,
  showEditGeneral,
}) => {
  const theme = useTheme();

  const [allChecked, setAllChecked] = useState(false);

  const handleChangeCheckbox = (key, isChecked, isSelectedId) => {
    if (key !== 'CHECK_ALL') {
      setTableData(prev => prev.map(item => (item.id === isSelectedId ? { ...item, checked: isChecked } : item)));
    } else {
      setTableData(prev => prev.map(item => ({ ...item, checked: isChecked })));
    }
  };

  const handleClickRow = item => {
    setDrawerOpen(true);
    setSelectedRowItem(item);
  };

  useEffect(() => {
    if (tableData?.length > 0) {
      setAllChecked(tableData.every(row => row.checked));
      setHasChecked(tableData.some(row => row.checked));
      setIsSelectedCount(tableData.filter(item => item.checked)?.length || 0);
    } else {
      setAllChecked(false);
      setHasChecked(false);
      setIsSelectedCount(0);
      setSelectedRowItem(null);
    }
  }, [tableData]);

  return (
    <TableContainer className={mainStyle['custom-scrollbar']}>
      <Table>
        <TableHead
          sx={{
            '& th': {
              color: '#aaaaaa',
              fontSize: '15px',
              fontWeight: '500',
            },
            borderTop: 'none',
            borderColor: '1px solid #d5d5d5',
          }}
        >
          <TableRow sx={{ backgroundColor: '#ffffff' }}>
            {showEditGeneral && (
              <TableCell
                sx={{
                  '&:not(:last-of-type)::after': {
                    display: 'none',
                  },
                }}
              >
                <Checkbox
                  icon={hasChecked ? <CheckClearIcon style={{ width: '24px', height: '24px' }} /> : <CheckBoxDefault style={{ width: '24px', height: '24px' }} />}
                  checkedIcon={<CheckBoxFilled style={{ width: '24px', height: '24px' }} />}
                  checked={allChecked}
                  onChange={e => handleChangeCheckbox('CHECK_ALL', e.target.checked)}
                  sx={{
                    '&:hover': { backgroundColor: 'transparent' },
                  }}
                />
              </TableCell>
            )}

            <TableCell>
              <Typography className={mainStyle['table-header']}>Captive Portal Name</Typography>
            </TableCell>
            <TableCell>
              <Typography className={mainStyle['table-header']}>Authentication Type</Typography>
            </TableCell>
            <TableCell>
              <Typography className={mainStyle['table-header']}>Preview</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData?.length > 0 ? (
            tableData.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage).map((item, index) => (
              <TableRow
                key={`captive-portal-table-row-${index}`}
                sx={{
                  position: 'relative',
                  backgroundColor: index % 2 === 1 ? theme.palette.primary.whiteSecound : theme.palette.primary.white,
                  cursor: 'pointer',
                  boxShadow: selectedRowItem?.id === item?.id ? `0 0 0 2px ${theme.palette.primary.greenPrimary} inset` : '',
                }}
                onClick={() => handleClickRow(item)}
              >
                {showEditGeneral && (
                  <TableCell>
                    <Checkbox
                      icon={<CheckBoxDefault style={{ width: '24px', height: '24px' }} />}
                      checkedIcon={<CheckBoxFilled style={{ width: '24px', height: '24px' }} />}
                      checked={item.checked}
                      onClick={e => e.stopPropagation()}
                      onChange={e => handleChangeCheckbox('NOT_CHECK_ALL', e.target.checked, item.id)}
                      sx={{
                        '&:hover': { backgroundColor: 'transparent' },
                      }}
                    />
                  </TableCell>
                )}
                <TableCell>
                  <Typography>{item.captivePortalName}</Typography>
                </TableCell>
                <TableCell>
                  <Typography>{item.authTypeLabel}</Typography>
                </TableCell>
                <TableCell>
                  <IconButton
                    sx={{
                      '& .hoverIcon': {
                        display: 'none',
                      },
                      '&:hover .defaultIcon': {
                        display: 'none',
                      },
                      '&:hover .hoverIcon': {
                        display: 'inline-flex',
                      },
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      setOpenPreviewModal(true);
                    }}
                  >
                    <PreviewIcon className="defaultIcon" />
                    <PreviewHoverIcon className="hoverIcon" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={showEditGeneral ? 4 : 3} sx={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }} />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CaptivePortalTable;
